import * as _ from 'lodash';
import {GEO_TYPES} from '../constants';

/**
 * @class
 * @property {number|string} id - у полигона id строка
 * @property {string} type
 * @property {string} text
 * @property {?Region} parentRegion - родительский регион
 * @property {?number[]} coordinates - координаты (используются для центрирования карты)
 * @property {?object} geoObject - геометрия (для полигона и окружности)
 */
export default class GeoItem {
  constructor(type, id, text, parentRegion, coordinates, geoObject) {
    // Если неизвестный тип гео, продолжаем, но предупреждаем
    if (!_.includes(_.values(GEO_TYPES), type)) {
      console.error(`Неизвестный геотип "${type}", возможны проблемы.`);
    }

    this.type = type;
    this.id = id;
    this.text = text;
    this.parentRegion = parentRegion;
    this.coordinates = coordinates;
    this.geoObject = geoObject;
  }
}


// WEBPACK FOOTER //
// ./src/serp/classes/GeoItem.js